export default function InfoContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col rounded-2xl bg-white px-4 py-5 dark:bg-slate-700 md:px-8">
      {children}
    </div>
  );
}
